import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { setUser, resetAuth } from '../authSlice';

interface AdminUIState {
  selectedOrganizationId: number;
  selectedPropertyId: number;
  expandedMenuIds: string[];
  isMenuOpen: boolean;
}

const initialState: AdminUIState = {
  selectedOrganizationId: 0,
  selectedPropertyId: 0,
  expandedMenuIds: ['community'],
  isMenuOpen: false,
};

const adminUISlice = createSlice({
  name: 'adminUI',
  initialState,
  reducers: {
    setSelectedOrganizationId: (state, action: PayloadAction<number>) => {
      state.selectedOrganizationId = action.payload;
    },
    setSelectedPropertyId: (state, action: PayloadAction<number>) => {
      state.selectedPropertyId = action.payload;
    },
    toggleExpandedMenuId: (state, action: PayloadAction<string>) => {
      const idx = state.expandedMenuIds.indexOf(action.payload);
      if (idx >= 0) {
        state.expandedMenuIds.splice(idx, 1);
      } else {
        state.expandedMenuIds.push(action.payload);
      }
    },
    setExpandedMenuIds: (state, action: PayloadAction<string[]>) => {
      state.expandedMenuIds = action.payload;
    },
    setIsMenuOpen: (state, action: PayloadAction<boolean>) => {
      state.isMenuOpen = action.payload;
    },
    toggleMenu: (state) => {
      state.isMenuOpen = !state.isMenuOpen;
    },
    resetAdminUI: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      // Set defaults when user is set (admin login via RTK Query)
      .addCase(setUser, (state, action) => {
        const user: any = action.payload;
        if (user?.roles && user.roles.length > 0) {
          // Get first organization and property from roles
          const firstRole = user.roles[0];
          if (firstRole.organizationId && state.selectedOrganizationId === 0) {
            state.selectedOrganizationId = firstRole.organizationId;
          }
          if (firstRole.propertyId && state.selectedPropertyId === 0) {
            state.selectedPropertyId = firstRole.propertyId;
          }
        }
      })
      // Reset UI state on auth reset (logout)
      .addCase(resetAuth, () => {
        return initialState;
      });
  },
});

export const {
  setSelectedOrganizationId,
  setSelectedPropertyId,
  toggleExpandedMenuId,
  setExpandedMenuIds,
  setIsMenuOpen,
  toggleMenu,
  resetAdminUI,
} = adminUISlice.actions;

export default adminUISlice.reducer;
